import styled from 'styled-components'

import { CloseOutline } from '@styled-icons/evaicons-outline'

export const AnnouncementBannerWrapper = styled.section`
  width: 100%;
  min-height: 32px;
  color: #222222;
  z-index: 3;

  @media (max-width: 767px) {
    min-height: 0; /* Isso resolve o problema no mobile */
  }
`

export const Container = styled.div`
  max-width: 1344px;
  margin: 0 auto;
  padding: 16px 48px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 16px;

  :not(:lang(pt)) {
    display: none;
  }

  @media (max-width: 767px) {
    align-items: flex-start;
    padding: 16px 24px;
    gap: 8px;
  }
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  column-gap: 16px;

  p {
    font-size: 14px;
    line-height: 22px;
    text-align: center;
  }

  span {
    margin-right: 12px;
  }

  a,
  strong {
    display: inline-block;
  }

  strong {
    font-weight: bold;
    white-space: nowrap;
  }

  a {
    color: var(--orange);
    text-decoration: none;
    padding: 2px 0;
    font-weight: bold;
    border-bottom: 1px solid var(--orange);
    transition: border-bottom 0.2s;

    white-space: nowrap;
  }

  @media (max-width: 767px) {
    justify-content: flex-start;
    p {
      text-align: left;
    }
  }
`

export const CloseModal = styled.button`
  background-color: transparent;
  appearance: none;
  border: 0;

  @media (max-width: 767px) {
    margin-right: -12px;
  }
`

export const CloseIcon = styled(CloseOutline)`
  width: 24px;
  height: 24px;
  color: #727272;
  transition: opacity 0.2s;

  :hover {
    opacity: 0.85;
  }
`
